import { Component, OnInit } from '@angular/core';
import { DashboardContainer } from './dashboard.container';
import { Router } from '@angular/router';

@Component({
    selector: 'app-user-dashboard',
    templateUrl: 'dashboard.component.html',
    styleUrls: ['./dashboard.component.css', './dashboard.component.scss']
})

export class DashboardComponent implements OnInit {

    profileImage = '../../../assets/img/unknown_quotes.jpg';

    constructor(private dashboardContainer: DashboardContainer, protected router: Router) { }

    getBookings = () => this.dashboardContainer.lastBookings;

    getRequests = () => this.dashboardContainer.allRequests;

    getProfileImage() {
        this.dashboardContainer.getUserInfo()
            .subscribe(userInfo => {
                if (userInfo.photo === null || userInfo.photo === null) {
                    this.profileImage = '../../../assets/img/unknown_quotes.jpg';
                } else {
                    this.profileImage = 'data:image/jpeg;base64,' + userInfo.photo;
                }
            });
    }

    ngOnInit() {
        this.dashboardContainer.changeHeader();
        this.dashboardContainer.getAllActiveRequestsByUser();
        this.getProfileImage();
    }

    goBack() {
        window.history.back();
    }

    goToNewSearch() {
        this.router.navigate(['/search']);
    }

    removeRequest(requestId) {
        this.dashboardContainer.removeRequest(requestId);
    }

    isMobile = () => (window.innerWidth < 992) ? true : false;

}
